import {EntityUnfollowedEvent} from './EntityUnfollowedEvent';

export class MatchUnfollowed extends EntityUnfollowedEvent {}
